import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';
import { selectUserIsIdentified } from 'core/selectors/user';
import {
  selectTopStoresIsLoading, selectTopStoresIsLoaded, selectTopStoresRecords,
} from '../selectors';

export const useGetMerchants = (config) => {
  const userIsIdentified = useSelector(selectUserIsIdentified);
  const dispatch = useDispatch();

  const isLoaded = useSelector(selectTopStoresIsLoaded);
  const isLoading = useSelector(selectTopStoresIsLoading);
  const merchants = useSelector(selectTopStoresRecords);

  const {
    api: {
      options, params, loggedInParams, loggedOutParams,
    },
  } = config;

  const customParams = {
    ...params,
    ...(userIsIdentified ? loggedInParams : loggedOutParams),
  };

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      dispatch(fetchPlacements(customParams, options));
    }
  }, []);

  return {
    isLoaded,
    isLoading,
    merchants,
  };
};
